import { render, staticRenderFns } from "./resultlookup.vue?vue&type=template&id=65ecd4c8&"
import script from "./resultlookup.vue?vue&type=script&lang=js&"
export * from "./resultlookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports